import { createContext } from "react";

export const LoyalityReportContext = createContext(null);
